import COLOR_PALETTE from './color-palette'

export const GENERAL_STYLE = {
  OPACITY_HOVER: '0.6',
}

export const GENERAL_STYLE_HEADING = {
  COLOR: COLOR_PALETTE.BLACK,
  LETTER_SPACING: '0.2em',
  FONT_WEIGHT: 600,
  LINE_HEIGHT: 1.2,
}

export const GENERAL_STYLE_COPY = {
  COLOR: COLOR_PALETTE.BLACK,
  FONT_WEIGHT: 200,
  LINE_HEIGHT: 1.4,
}

export const BASE_HEADING = {
  color: GENERAL_STYLE_HEADING.COLOR,
  letterSpacing: GENERAL_STYLE_HEADING.LETTER_SPACING,
  fontWeight: GENERAL_STYLE_HEADING.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_HEADING.LINE_HEIGHT,
  textTransform: 'uppercase',
}

export const BASE_COPY = {
  color: GENERAL_STYLE_COPY.COLOR,
  fontWeight: GENERAL_STYLE_COPY.FONT_WEIGHT,
  lineHeight: GENERAL_STYLE_COPY.LINE_HEIGHT,
}



// WEBPACK FOOTER //
// ./src/constants/general-style.js